"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _hoisted_1 = ["id"];
const _hoisted_2 = { class: "font-bold lg:hidden" };
const _hoisted_3 = { key: 0 };
const _hoisted_4 = { key: 0 };
const _hoisted_5 = { class: "text-sm" };
const _hoisted_6 = /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "relative top-0.5 marso-icon-recycle tooltip text-green" }, null, -1);
const _hoisted_7 = {
    key: 1,
    class: "font-bold"
};
const _hoisted_8 = { key: 1 };
const _hoisted_9 = { key: 0 };
const _hoisted_10 = { class: "text-sm" };
const _hoisted_11 = /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "relative top-0.5 marso-icon-recycle tooltip text-green" }, null, -1);
const _hoisted_12 = { class: "font-bold" };
const _hoisted_13 = { key: 0 };
const _hoisted_14 = /*#__PURE__*/ (0, vue_2.createElementVNode)("button", {
    type: "button",
    class: "button-warehouse-specific-price"
}, [
    /*#__PURE__*/ (0, vue_2.createElementVNode)("span", { class: "tooltip" }, [
        /*#__PURE__*/ (0, vue_2.createElementVNode)("span", { class: "icon marso-icon-info-circle" })
    ])
], -1);
const _hoisted_15 = { key: 1 };
const tagStore_1 = require("../../../stores/tag/tagStore");
const i18n_1 = require("../../../common/i18n");
const shop_1 = require("../../../common/utils/shop");
exports.default = (0, vue_1.defineComponent)({
    __name: 'RetailPriceCell',
    props: {
        product: null
    },
    setup(__props) {
        const tagStore = (0, tagStore_1.useTagStore)();
        return (_ctx, _cache) => {
            return ((0, vue_2.unref)(tagStore).tags.columns.retailPriceColumn.display)
                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("td", {
                    key: 0,
                    id: `retail-price-cell-${__props.product.id}`,
                    class: "grid grid-cols-2 border-b border-gray px-4 py-2 lg:table-cell lg:py-1"
                }, [
                    (!__props.product.priceOptions.length)
                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)(vue_2.Fragment, { key: 0 }, [
                            (0, vue_2.createElementVNode)("div", _hoisted_2, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)('retail_price', 'Retail price', 'retail_price_cell')), 1),
                            (0, vue_2.createElementVNode)("div", null, [
                                ((0, vue_2.unref)(tagStore).tags.switches.grossPriceSwitch.value)
                                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_3, [
                                        (__props.product.prices.priceEprNet && __props.product.prices.priceVatPercent)
                                            ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_4, [
                                                (0, vue_2.createTextVNode)((0, vue_2.toDisplayString)((0, vue_2.unref)(shop_1.formatPrice)(__props.product.prices.priceRetailNet - __props.product.prices.priceEprNet, (0, vue_2.unref)(tagStore).customerCurrencyCode || __props.product.prices.currencyCode, { vatPercent: __props.product.prices.priceVatPercent })) + " ", 1),
                                                (0, vue_2.createElementVNode)("div", _hoisted_5, [
                                                    _hoisted_6,
                                                    (0, vue_2.createTextVNode)("️ " + (0, vue_2.toDisplayString)((0, vue_2.unref)(shop_1.formatPrice)(__props.product.prices.priceEprNet, (0, vue_2.unref)(tagStore).customerCurrencyCode || __props.product.prices.currencyCode, { vatPercent: __props.product.prices.priceVatPercent })), 1)
                                                ])
                                            ]))
                                            : (0, vue_2.createCommentVNode)("", true),
                                        (__props.product.prices.priceVatPercent)
                                            ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_7, (0, vue_2.toDisplayString)((0, vue_2.unref)(shop_1.formatPrice)(__props.product.prices.priceRetailNet + __props.product.prices.priceEcoNet, (0, vue_2.unref)(tagStore).customerCurrencyCode || __props.product.prices.currencyCode, { vatPercent: __props.product.prices.priceVatPercent })), 1))
                                            : (0, vue_2.createCommentVNode)("", true)
                                    ]))
                                    : ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_8, [
                                        (__props.product.prices.priceEprNet)
                                            ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_9, [
                                                (0, vue_2.createTextVNode)((0, vue_2.toDisplayString)((0, vue_2.unref)(shop_1.formatPrice)(__props.product.prices.priceRetailNet - __props.product.prices.priceEprNet, (0, vue_2.unref)(tagStore).customerCurrencyCode || __props.product.prices.currencyCode)) + " ", 1),
                                                (0, vue_2.createElementVNode)("div", _hoisted_10, [
                                                    _hoisted_11,
                                                    (0, vue_2.createTextVNode)("️ " + (0, vue_2.toDisplayString)((0, vue_2.unref)(shop_1.formatPrice)(__props.product.prices.priceEprNet, (0, vue_2.unref)(tagStore).customerCurrencyCode || __props.product.prices.currencyCode)), 1)
                                                ])
                                            ]))
                                            : (0, vue_2.createCommentVNode)("", true),
                                        (0, vue_2.createElementVNode)("div", _hoisted_12, (0, vue_2.toDisplayString)((0, vue_2.unref)(shop_1.formatPrice)(__props.product.prices.priceRetailNet + __props.product.prices.priceEcoNet, (0, vue_2.unref)(tagStore).customerCurrencyCode || __props.product.prices.currencyCode)), 1)
                                    ]))
                            ])
                        ], 64))
                        : ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)(vue_2.Fragment, { key: 1 }, [
                            (!(0, vue_2.unref)(tagStore).tags.switches.customPriceSwitch.value)
                                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_13, [
                                    (0, vue_2.createTextVNode)((0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("warehouse_specific_price", "Warehouse-specific price", "wholesale_price_cell")) + " ", 1),
                                    _hoisted_14
                                ]))
                                : ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_15))
                        ], 64))
                ], 8, _hoisted_1))
                : (0, vue_2.createCommentVNode)("", true);
        };
    }
});
